import React from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';


const ReturnLink = () => (
  <Link to={-1}>
    Go Back
  </Link>
)

export const NotFound = () => {
  const navigate = useNavigate();
  return (
    <main>
      {/* Blue header banner (matches the rest of the app) */}
      <div className="full-row light-blue">
        <div className="container-fluid">
          <div className="row text-white pt-3 pb-3">
            <div className="col-md-12 text-white">
              <h1 className="text-uppercase">Something Went Wrong</h1>
              <p>We couldn't find that page</p>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="full-row white">
        <div className="container-fluid">
          <Box
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 2,
              backgroundColor: '#fffbeb',
              border: '1px solid #f59e0b',
              borderRadius: 2,
              p: { xs: 2, sm: 3 },
              mt: 3,
            }}
          >
            {/* Orange circular warning icon */}
            <Box
              sx={{
                flexShrink: 0,
                width: 48,
                height: 48,
                borderRadius: '50%',
                backgroundColor: '#f59e0b',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                <line x1="12" y1="9" x2="12" y2="13" />
                <line x1="12" y1="17" x2="12.01" y2="17" />
              </svg>
            </Box>

            <Box>
              <Typography sx={{ fontWeight: 700, color: '#212540', fontSize: 18, mb: 0.5 }}>
                The page you're looking for may have been moved, deleted, or the link may be incorrect.
              </Typography>
              <Typography variant="body2" sx={{ color: '#212540', mb: 2 }}>
                No worries - let's get you back on track.
              </Typography>
              <Button
                variant="contained"
                onClick={() => navigate('/events')}
                sx={{
                  backgroundColor: '#003063',
                  '&:hover': { backgroundColor: '#002145' },
                  textTransform: 'uppercase',
                  fontWeight: 700,
                }}
              >
                See Opportunities
              </Button>
            </Box>
          </Box>
        </div>
      </div>
    </main>
  );
};


export const NoResults = () => (
  <div className="Error Error-Label">
      Whoops, looks like the your search didn't find any results.  Please try again!
  </div>
)


export const NotAuthorized = () => (
  <section>
    <h1>Oops!</h1>
    <p>Looks like you don't have access.</p>
    <br />
    <ReturnLink />
  </section>
);

export const RegistrationThanks = (props) => (
  <div>
    <h1>`Thank you for registering for ${props.bomEvent.BP_Title}`</h1>
    <Link to="/events">
      View other events
    </Link>
  </div>
);